import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationChatWithCustomerSupport = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationChatWithCustomerSupport',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 101 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70735)",
    fillRule: "evenodd",
    d: "M59.861 7.94c3.82 0 6.917 3.667 7.021 8.227v31.17c0 4.598-3.04 8.332-6.83 8.455H29.915L14.298 67.934l.019-12.142-7.296.01C3.2 55.802.105 52.135 0 47.575V16.404c0-4.598 3.04-8.332 6.83-8.455h53.031v-.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70735)",
    fillRule: "evenodd",
    d: "M40.13 33.742c-3.818 0-6.916 3.668-7.02 8.228v31.17c0 4.598 3.04 8.332 6.83 8.455h30.145l15.619 12.132-.02-12.141 7.297.01c3.819 0 6.916-3.668 7.02-8.228V42.207c0-4.598-3.04-8.332-6.83-8.455H40.13v-.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#3C3B40",
    d: "M66.557 61.873a4.494 4.494 0 1 0 0-8.987 4.494 4.494 0 0 0 0 8.987ZM52.574 61.873a4.494 4.494 0 1 0 0-8.987 4.494 4.494 0 0 0 0 8.987ZM80.533 61.873a4.494 4.494 0 1 0 0-8.987 4.494 4.494 0 0 0 0 8.987Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70735",
    x1: 17.535,
    x2: 54.41,
    y1: -11.823,
    y2: 57.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.556,
    stopColor: "#C691E2"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.934,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70735",
    x1: 78.647,
    x2: 56.467,
    y1: 90.892,
    y2: 29.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.173,
    stopColor: "#4BC7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.999,
    stopColor: "#DEFBA9"
  }))));
};
ColoredIllustrationChatWithCustomerSupport.displayName = 'ColoredIllustrationChatWithCustomerSupport';
export default withProvisionalOverrideFromContext(ColoredIllustrationChatWithCustomerSupport);
//# sourceMappingURL=index.js.map